/**
 * @voltxampere/ui — 4070 quad XOR CMOS variant (Sprint 41-5)
 *
 * Reference: TI CD4070. Engine zero-diff invariant honored —
 * canonical "digital-gate" via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic4070 = {
    id: "4070",
    nameTr: "4070 (4'lü XOR CMOS, DIP-14)",
    nameEn: "4070 (Quad XOR CMOS, DIP-14)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "4070",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "XOR",
        vHigh: 5,
        vLow: 0,
        threshold: 2.5,
        propagationDelay: 200e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-4070.js.map